// removed by extract-text-webpack-plugin
module.exports = {"img-loading":"img-loading"};


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/Loading/style.less
// module id = 399
// module chunks = 438